module.exports = __webpack_public_path__ + "media/images/front/marker_old-316d5c29bc54d953efba7fd1a30e6855.png";